import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  divider: {
    width: "100%",
    height: "100vh",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  }
});

const DividerImage = ({ classes, image }) => (
  <div
    style={{ backgroundImage: `url(${image})` }}
    className={classes.divider}
  />
);

DividerImage.propTypes = {
  classes: PropTypes.object,
  image: PropTypes.string
};

export default injectSheet(styles)(DividerImage);



// WEBPACK FOOTER //
// ./src/components/DividerImage.jsx